module.exports = __webpack_public_path__ + "static/media/tela-passo-04.c01b75bb.jpg";